<div class="inbuilt-visual-wrapper-v2">
  <div class="card-header" *ngIf="heading || (isJSONeditorEnabled && elementData?.type !== 'header')">
    <div class="header-content">
      <h4 class="card-title" *ngIf="heading">{{ heading }}</h4>
      <a 
        *ngIf="hasNavigationLink" 
        class="more-details-link" 
        [matTooltip]="navigationTooltip"
        matTooltipPosition="above"
        (click)="handleNavigationClick()" 
      >
        <mat-icon class="info-icon">info</mat-icon>
        More Info
      </a>
      <span *ngIf="isJSONeditorEnabled && elementData?.type !== 'header'" class="json-editor-icon">
        <mat-icon title="Edit Element JSON" (click)="openJSONeditor()">create</mat-icon>
        <mat-icon class="ms-1" title="Delete Report" (click)="deleteReport()">delete</mat-icon>
      </span>
    </div>
  </div>

  <div class="card-body">
    <ng-content></ng-content>
  </div>
</div>

<app-modal [maximizable]="true" [inViewport]="true" #modalEditJSON class="modal-demo edit-json-popup"
    (closeModal)="hidepopup('edit')">
    <ng-container class="app-modal-header">Visual Editor</ng-container>
    <ng-container class="app-modal-body">
        <ng-container *ngIf="isJSONeditorPopupOpen">
            <app-inbuilt-editor [initialJson]="elementData?.element_json || {}" [queryCode]="elementData?.Constructed_Query || ''" (jsonTextChange)="onJsonEditorTextChange($event)"></app-inbuilt-editor>
        </ng-container>
    </ng-container>
</app-modal>

